import PropTypes from 'prop-types';

function TenantInactive({ isActive }) {
  if (!isActive)
    return (
      <>
        <br />
        <b>
          <i>** Your account is inactive. Please contact Polycom support.</i>
        </b>
      </>
    );

  return null;
}

TenantInactive.propTypes = {
  isActive: PropTypes.bool,
};

export default TenantInactive;
